import { IState } from '../../store';
import { IMediaItem } from '../../types/newbuildingTiledCarousel';
import { getNewbuildingTiledCarouselPhotos } from './getNewbuildingTiledCarouselPhotos';

export const getNewbuildingTiledCarouselFirstThreePhotos = (state: IState): IMediaItem[] => {
  const photos = getNewbuildingTiledCarouselPhotos(state);

  return photos.slice(0, 3);
};
